import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to track the last location (replacement for react-router-last-location)
 * This is needed because react-router-last-location is not compatible with React 18
 *
 * @returns {Object|null} The previous location object or null if no previous location
 */
function useLastLocation() {
  const location = useLocation();
  const lastLocationRef = useRef(null);
  const currentLocationRef = useRef(location);

  useEffect(() => {
    // Update lastLocation to be the previous currentLocation
    lastLocationRef.current = currentLocationRef.current;
    // Update currentLocation to the new location
    currentLocationRef.current = location;
  }, [location]);

  return lastLocationRef.current;
}

export default useLastLocation;
